import {PayloadAction, createSlice} from '@reduxjs/toolkit'
import {
  RemarqueState,
  FetchRemarquesResponse,
  FetchRemarqueByIdResponse,
  FetchAllRemarquesResponse,
  CheckRemarqueResponse,
} from './types'
import {
  fetchRemarqueById,
  fetchRemarques,
  createRemarque,
  updateRemarque,
  deleteRemarque,
  checkRemarque,
  fetchAllRemarques,
} from './service'
import {ResponseError} from '../commonTypes'

const initialState: RemarqueState = {
  remarqueForEdit: null,
  remarques: [],
  total: 0,
  totalPages: 0,
  progress: 0,
  listLoading: false,
  actionLoading: false,
  error: null,
}
const remarqueSlice = createSlice({
  name: 'remarque',
  initialState,
  reducers: {
    handleRequestProgress: (state: RemarqueState, action: any) => {
      const {progress} = action.payload
      state.progress = progress
    },
    resetRemarques: (state: RemarqueState) => {
      state.remarques = []
      state.total = 0
      state.totalPages = 0
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchRemarques.pending, (state: RemarqueState) => {
      state.listLoading = true
      state.error = null
    })
    builder.addCase(fetchRemarques.rejected, (state: RemarqueState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.listLoading = false
    })
    builder.addCase(
      fetchRemarques.fulfilled,
      (state: RemarqueState, action: PayloadAction<FetchRemarquesResponse>) => {
        state.listLoading = false
        state.error = null
        const {remarques, total, totalPages} = action.payload
        state.remarques = remarques
        state.total = total
        state.totalPages = totalPages
      }
    )

    builder.addCase(fetchAllRemarques.pending, (state: RemarqueState) => {
      state.listLoading = true
      state.error = null
    })
    builder.addCase(
      fetchAllRemarques.rejected,
      (state: RemarqueState, action: PayloadAction<any>) => {
        const {error} = action.payload
        state.error = error
        state.listLoading = false
      }
    )
    builder.addCase(
      fetchAllRemarques.fulfilled,
      (state: RemarqueState, action: PayloadAction<FetchAllRemarquesResponse>) => {
        state.listLoading = false
        state.error = null
        const {remarques} = action.payload
        state.remarques = remarques
      }
    )

    builder.addCase(fetchRemarqueById.pending, (state: RemarqueState) => {
      state.listLoading = true
      state.error = null
    })
    builder.addCase(
      fetchRemarqueById.rejected,
      (state: RemarqueState, action: PayloadAction<any>) => {
        const {error} = action.payload
        state.error = error
        state.listLoading = false
      }
    )
    builder.addCase(
      fetchRemarqueById.fulfilled,
      (state: RemarqueState, action: PayloadAction<FetchRemarqueByIdResponse>) => {
        state.remarqueForEdit = action.payload.remarque
        state.listLoading = false
        state.error = null
        state.remarqueForEdit = action.payload.remarque
      }
    )

    builder.addCase(createRemarque.pending, (state: RemarqueState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(createRemarque.rejected, (state: RemarqueState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.actionLoading = false
      state.progress = undefined
    })
    builder.addCase(
      createRemarque.fulfilled,
      (state: RemarqueState, action: PayloadAction<FetchRemarqueByIdResponse>) => {
        state.remarqueForEdit = action.payload.remarque
        state.actionLoading = false
        state.error = null
        state.progress = undefined
      }
    )

    builder.addCase(updateRemarque.pending, (state: RemarqueState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(updateRemarque.rejected, (state: RemarqueState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.actionLoading = false
    })
    builder.addCase(
      updateRemarque.fulfilled,
      (state: RemarqueState, action: PayloadAction<FetchRemarqueByIdResponse>) => {
        state.remarqueForEdit = action.payload.remarque
        state.actionLoading = false
        state.error = null
      }
    )

    builder.addCase(deleteRemarque.pending, (state: RemarqueState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(deleteRemarque.rejected, (state: RemarqueState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.actionLoading = false
    })
    builder.addCase(
      deleteRemarque.fulfilled,
      (state: RemarqueState, action: PayloadAction<FetchRemarqueByIdResponse>) => {
        state.remarqueForEdit = action.payload.remarque
        state.actionLoading = false
        state.error = null
      }
    )

    builder.addCase(checkRemarque.pending, (state: RemarqueState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(checkRemarque.rejected, (state: RemarqueState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.actionLoading = false
    })
    builder.addCase(
      checkRemarque.fulfilled,
      (state: RemarqueState, action: PayloadAction<CheckRemarqueResponse>) => {
        state.remarqueForEdit = action.payload.remarque
        state.actionLoading = false
        state.error = null
      }
    )
  },
})

export default remarqueSlice.reducer
export const actions = remarqueSlice.actions
